import { render, staticRenderFns } from "./TheTeam.vue?vue&type=template&id=2a95c856&"
import script from "./TheTeam.vue?vue&type=script&lang=js&"
export * from "./TheTeam.vue?vue&type=script&lang=js&"
import style0 from "./TheTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports